import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

// Créer un événement personnalisé pour signaler un changement de langue
export const LANGUAGE_CHANGE_EVENT = 'language-changed';

export const LanguageProvider = ({ children }) => {
  // Récupérer la langue depuis localStorage ou utiliser 'fr' par défaut
  const [language, setLanguage] = useState(() => {
    const savedLanguage = localStorage.getItem('1000Shake-language');
    return savedLanguage ? savedLanguage : 'fr';
  });

  // Sauvegarder la langue dans localStorage à chaque changement
  useEffect(() => {
    localStorage.setItem('1000Shake-language', language);
  }, [language]);

  const toggleLanguage = () => {
    const newLanguage = language === 'en' ? 'fr' : 'en';
    setLanguage(newLanguage);
    
    // Émettre un événement personnalisé que d'autres composants peuvent écouter
    const event = new CustomEvent(LANGUAGE_CHANGE_EVENT, { detail: { language: newLanguage } });
    document.dispatchEvent(event);
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);